import React, {
  useState,
  useEffect,
  useContext,
  useLayoutEffect,
  useMemo,
} from "react";
import { AuthContext } from "../../contexts/AuthContext";
import axios from "axios";
import Header from "../../layout/Header/Header";

import { Row, Input, Col } from "reactstrap";
import Swal from "sweetalert2";
import {
  DashPage,
  FilterBar,
  Filtro,
  KpiRow,
  DashCard,
  ChartBox,
  montarGraficas,
  graficaBarras,
} from "./dashboardUI";

function DashboardCXP() {
  const { user } = useContext(AuthContext);
  const URL_PROVEEDORES = process.env.REACT_APP_URL_PROVEEDORES;
  const URL_ARTICULOS_EMBARQUES = process.env.REACT_APP_URL_ARTICULOS_EMBARQUES;
  const URL_ARTICULOS_OC = process.env.REACT_APP_URL_ARTICULOS_OC;

  const [graficas, setGraficas] = useState([]);
  const [proveedores, setProveedores] = useState([]); 
  const [selectedProveedor, setSelectedProveedor] = useState("");
 
  const [info, setInfo] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [cargos, setCargos] = useState(0);
  const [abonos, setAbonos] = useState(0);
  const [saldo, setSaldo] = useState(0);

  const [pendRecibir, setPendRecibir] = useState(0);
  const [infoPendRecibir, setInfoPendRecibir] = useState([]);
  const [pendEmbarcar, setPendEmbarcar] = useState(0);
  const [infoPendEmbarcar, setInfoPendEmbarcar] = useState([]);

  const Toast = Swal.mixin({
    toast: true,
    position: "center",
    showConfirmButton: false,
    // timer: 5000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener("mouseenter", Swal.stopTimer);
      toast.addEventListener("mouseleave", Swal.resumeTimer);
    },
  });

  if (cargando) {
    Toast.fire({
      html: `<i class="fas fa-hourglass-half custom-spin fa-2x" style="margin-right: 16px;"></i>`, // Ícono de carga animado
      title: "Danos unos segundos....",
      customClass: {
        icon: 'animated-icon'
      }
    });
  }
  
  useEffect(() => {
    axios
      .get(`${URL_PROVEEDORES}Tipo/China`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let totalCargos = 0;
        let totalAbonos = 0;
        let totalSaldo = 0;

        let allGraficas = response.data;
        let arrayTabla = allGraficas
          .sort((a, b) => (a.nombre_comercial > b.nombre_comercial ? 1 : -1))
          .map((a) => {
            if(a.cargos != 0 || a.abonos != 0 || a.saldo != 0){
            totalCargos = totalCargos + parseFloat(a.cargos);
            totalAbonos = totalAbonos + parseFloat(a.abonos);
            totalSaldo = totalSaldo + parseFloat(a.saldo);
            return {
              idProveedor: a._id,
              Proveedor: a.nombre_comercial,
              Cargos: parseFloat(a.cargos),
              Abonos: parseFloat(a.abonos),
              Saldo: parseFloat(a.saldo),
            }
          }
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinal = Object.values(arrayTabla);

        setInfo(dataFinal);
        setCargos(totalCargos);
        setAbonos(totalAbonos);
        setSaldo(totalSaldo);

        let unicosProv = dataFinal.filter(
          (value, index, self) =>
            index === self.findIndex((t) => t.idProveedor === value.idProveedor)
        );
        setProveedores(unicosProv);

        setCargando(false);
        Toast.close();
      })
      .catch((err) => {
        console.log(err);
      });

      axios
      .get(`${URL_ARTICULOS_EMBARQUES}PendRecibirDash`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allPendRecibir = response.data;
        let TEfe = allPendRecibir.map((c) => parseFloat(c.pendiente_recibir));
        let TE = TEfe.reduce((t, total, index) => t + total, 0);
        setInfoPendRecibir(allPendRecibir)
        setPendRecibir(TE)
      })
      .catch((err) => {
        console.log(err);
      });

      axios
      .get(`${URL_ARTICULOS_OC}/PendEmbarcarDash`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allPendEmbarcar = response.data;
        let TEfe = allPendEmbarcar.map((c) => parseFloat(c.pendiente_embarcar));
        let TE = TEfe.reduce((t, total, index) => t + total, 0);
        setInfoPendEmbarcar(allPendEmbarcar)
        setPendEmbarcar(TE)
      })
      .catch((err) => {
        console.log(err);
      });

  }, []);

  useMemo(()=>{
    let temp = info
    let tempEmb = infoPendEmbarcar
    let tempRec = infoPendRecibir
    if (selectedProveedor) {
      temp = temp.filter((e) =>
        e.idProveedor.includes(selectedProveedor)
      );

      tempEmb = tempEmb.filter((e) =>
      e.idProveedor.includes(selectedProveedor)
      );
    
    tempRec = tempRec.filter((e) =>
    e.idProveedor.includes(selectedProveedor)
     );

    }
    setGraficas(temp)

    let TCar = temp.map((c) => parseFloat(c.Cargos));
    let TC = TCar.reduce((t, total, index) => t + total, 0);
    setCargos(TC);

    let TAbo = temp.map((c) => parseFloat(c.Abonos));
    let TA = TAbo.reduce((t, total, index) => t + total, 0);
    setAbonos(TA);

    let TSal = temp.map((c) => parseFloat(c.Saldo));
    let TS = TSal.reduce((t, total, index) => t + total, 0);
    setSaldo(TS);

    let TRec = tempRec.map((c) => parseFloat(c.pendiente_recibir));
    let TR = TRec.reduce((t, total, index) => t + total, 0);
    setPendRecibir(TR)

    let TEmb = tempEmb.map((c) => parseFloat(c.pendiente_embarcar));
    let TE = TEmb.reduce((t, total, index) => t + total, 0);
    setPendEmbarcar(TE)


  },[info, selectedProveedor])

  useLayoutEffect(
    () =>
      montarGraficas([
        ["chartdiv", (root) => graficaBarras(root, {
          data: graficas, categoria: "Proveedor", series: [{ valor: "Saldo", nombre: "Saldo", color: "#f59e0b" }],
          moneda: true, horizontal: true, min0: false, etiquetas: true, exportar: true, archivo: "CXP_Saldos",
        })],
      ]),
    [graficas]
  );

  const kpis = [
    { label: "Saldo", value: saldo, formato: "moneda", icon: "fas fa-file-invoice-dollar", color: "#f59e0b" },
    { label: "Piezas por embarcar", value: pendEmbarcar, formato: "numero", icon: "fas fa-ship", color: "#3b82f6" },
    { label: "Piezas por recibir", value: pendRecibir, formato: "numero", icon: "fas fa-truck-loading", color: "#10b981" },
    { label: "Proveedores", value: graficas.length, formato: "entero", icon: "fas fa-industry", color: "#8b5cf6" },
  ];

  return (
    <>
      <Header />
      {/* {user.menu_reportes ? ( */}
      <DashPage
        icon="fas fa-chart-bar"
        color="#f59e0b"
        bg="#fffbeb"
        title="Dashboard CXP"
        subtitle="Cuentas por pagar a proveedores y mercancía en tránsito"
        cargando={cargando}
      >
        <FilterBar>
          <Filtro label="Proveedor">
            <Input
              bsSize="sm"
              type="select"
              value={selectedProveedor}
              onChange={(e) => {
                setSelectedProveedor(e.target.value);
              }}
            >
              <option value="">Todos</option>
              {proveedores
                .sort((a, b) => (a.Proveedor > b.Proveedor ? 1 : -1))
                .map((a) => {
                  return <option key={a.idProveedor} value={a.idProveedor}>{a.Proveedor}</option>;
                })}
            </Input>
          </Filtro>
        </FilterBar>

        <KpiRow items={kpis} />

        <Row className="dash-row">
          <Col md={12}>
            <DashCard icon="fas fa-file-invoice-dollar" color="#f59e0b" title="Saldo por proveedor" subtitle="Saldo pendiente de pago">
              <ChartBox
                id="chartdiv"
                height={Math.max(320, graficas.length * 28 + 60)}
                cargando={cargando}
                vacio={graficas.length === 0}
              />
            </DashCard>
          </Col>
        </Row>
      </DashPage>
      {/*  ) : undefined} */}
    </>
  );
}
export default DashboardCXP;
